import React, { useEffect, useState } from "react";
import { authSVC } from "../../services";
import { useB2BContext } from "../../context/ContextB2B";
import { calculatePrices } from "../../utils/calculatePrices";
// import CheckoutButton from "./CheckoutButton";
// import AddressPopup from "./Address";

function RequestedPackageHDFC({ requestedPackageData }: any) {
  const { getUserByID } = useB2BContext();
  const [paymentIsOK, setPaymentIsOK] = useState(false);
  const [paymentId, setPaymentId] = useState(false);
  const [amount, setAmount] = useState<any>("");
  const [taxAmount, setTaxAmount] = useState<any>("");
  const [amountWithOutTax, setAmountWithOutTax] = useState<any>("");
  const [taxRate, setTaxRate] = useState(18); // Default tax rate (10%)
  const [total, setTotal] = useState(0);
  const [showAddress, setShowAddress] = useState(true);
  const [companyState, setCompanyState] = useState("");
  const [paymentBreakDown, setPaymentBreakDown] = useState({
    igstTax: 0,
    cgst: 0,
    sgst: 0,
    subTotalAmount: 0,
    amountQuote: 0,
  });

  useEffect(() => {
    console.log(requestedPackageData, "requestedPackageData 123");
  }, [requestedPackageData]);

  useEffect(() => {
    setAmount(requestedPackageData?.price);
    setTaxAmount(requestedPackageData?.price * 0.18);
  }, [requestedPackageData]);

  // const packageDetails =
  //   requestedPackageData &&
  //   requestedPackageData?.map((pkg: any) => {
  //     const taxes = pkg.price * 0.18;
  //     const cgst = taxes / 2;
  //     const sgst = taxes / 2;
  //     const totalAmount = pkg.price + taxes; // Total amount including taxes
  //     const package_duration = pkg.package_duration;

  //     return {
  //       packageName: pkg.package_id.package,
  //       price: pkg.price,
  //       IGST: taxes.toFixed(2),
  //       CGST: cgst.toFixed(2),
  //       SGST: sgst.toFixed(2),
  //       totalAmount: totalAmount.toFixed(2),
  //       package_duration: package_duration,
  //       emp_unit: pkg.total_unit_employee,
  //       unit_price: pkg.unit_price_per_employee,
  //     };
  //   });

  // Calculate Subtotal
  // const subtotal = packageDetails.reduce(
  //   (sum: any, pkg: any) => sum + parseFloat(pkg.totalAmount),
  //   0
  // );

  // Display Package Details and Subtotal
  // console.log("Package Details:", packageDetails);
  // console.log("Subtotal:", subtotal.toFixed(2));

  const HDFCPaymentInitiate = () => {
    if (getUserByID) {
      authSVC
        .initateHRMSPayment({ company_id: getUserByID.company_id._id })
        .then((res) => {
          localStorage.setItem("ss_order_id", res.data.order_id);
          window.location.href = res.data.payment_links.web;
        })
        .catch();
    }
  };

  return (
    <>
      <div className="chekout_details">
        <div className="breakdown_wrapper">
          <h3 className="hr_breakdown text_left">Breakdown</h3>

          <div className="plan_name">
            <h2>{requestedPackageData?.package_id?.package} Membership</h2>
            <div className="duration"></div>
          </div>

          <div className="price_box">
            <ul>
              <li>
                <div>
                  <p>
                    {requestedPackageData?.package_id?.package} Membership -{" "}
                    {requestedPackageData?.package_duration}
                  </p>
                </div>
                <div>
                  <p>₹{amount}</p>
                </div>
              </li>
              <li>
                <div>
                  <p>Unit</p>
                </div>
                <div>
                  <p>{requestedPackageData?.total_unit_employee}</p>
                </div>
              </li>
              <li>
                <div>
                  <p>Price Per Person</p>
                </div>
                <div>
                  <p>₹{requestedPackageData?.unit_price_per_employee}</p>
                </div>
              </li>

              <li className="tax_details">
                {companyState.toLowerCase() === "haryana" ? (
                  <>
                    <div className="line">
                      <div>
                        <p>+ Taxes/ IGST (0)</p>
                      </div>
                      <div>
                        <p>₹00.00</p>
                      </div>
                    </div>
                  </>
                ) : (
                  <>
                    <div className="line">
                      <div>
                        <p>+ Taxes/ IGST (18%)</p>
                      </div>
                      <div>
                        <p>
                          ₹
                          {(Math.round(Number(taxAmount) * 100) / 100).toFixed(
                            2
                          )}
                        </p>
                      </div>
                    </div>
                  </>
                )}

                <div className="line tax" style={{ marginTop: "8px" }}>
                  <div className="gray">
                    <p>CGST (9%)</p>
                  </div>
                  <div>
                    {companyState.toLowerCase() === "haryana" ? (
                      <p>₹0.00</p>
                    ) : (
                      <p>₹{taxAmount / 2}</p>
                    )}
                  </div>
                </div>
                <div className="line tax">
                  <div className="gray">
                    <p>SGST/UTGST (9%)</p>
                  </div>
                  <div>
                    {companyState.toLowerCase() === "haryana" ? (
                      <p>₹0.00</p>
                    ) : (
                      <p>₹{taxAmount / 2}</p>
                    )}
                  </div>
                </div>
              </li>
              <li className="total_amount border">
                <div>
                  <p>Total Amount</p>
                </div>
                <div>
                  <p>
                    ₹{Math.floor(Number(amount) + Number(taxAmount)).toFixed(2)}
                  </p>
                </div>
              </li>
            </ul>
          </div>

          <div className="price_box">
            <ul>
              <li>
                <div>
                  <p>Subtotal</p>
                </div>
                <div>
                  <p>
                    ₹{Math.floor(Number(amount) + Number(taxAmount)).toFixed(2)}
                  </p>
                </div>
              </li>
            </ul>
          </div>
        </div>

        <button
          className="checkout_btn"
          onClick={HDFCPaymentInitiate}
          disabled={getUserByID?.company_id.package.length === 0 ? true : false}
        >
          Continue Checkout
        </button>
      </div>
      <p className="need_help">
        Need help?{" "}
        <a
          href="https://www.soulsara.world/contact-us"
          rel="noreferrer"
          target="_blank"
        >
          Contact Us
        </a>{" "}
      </p>
    </>
  );
}

export default RequestedPackageHDFC;
